/**
 * State for group
 */
export const state = {
  /**
   * Weather the new group that is being added is a video group
   */
  isVideo: false,
  /**
   * The list of all the members in the group
   * Format
   * {
   *  id: 18,
   *  type: "person" | "other_event" | "subscriber" | "app_user"
   * }[]
   */
  selected: []
};
